// src/api/geneCodes/SnpInterventionsApi.ts
import { ENV } from "../../config/runtimeEnv";
import { SnpInterventionsResponse } from "../../types/geneCodes/InterventionTypes";
import { http } from "../../lib/http/client";

const API_BASE_URL = ENV.VITE_LABIQ_SERVER;

export const fetchSnpInterventions = async (sampleId: string, category: string, sex?: string): Promise<SnpInterventionsResponse> => {
	const params: Record<string, string> = { sample_id: sampleId, category };

	if (sex) {
		params.sex = sex;
	}

	const response = await http.get(`${API_BASE_URL}/snp-interventions`, {
		params,
	});

	return response.data;
};
